module.exports = __webpack_public_path__ + "img/logo-icon.2bc29860.svg";